import React from 'react';
import {
    Form,
    Input,
    Select,
    Col,
    Row,
    InputNumber,
    message,
    Button,
    Popconfirm,
    Tooltip,
    DatePicker,
    Radio
} from 'antd';
import Cookies from 'js-cookie';
import ModalDom from '../../../../components/Modal';
import DetailTitle from '../../../../components/DetailTitle';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import { post, config, postFrom } from '../../../../axios';
import {formatTime, handleExportParams} from "../../../../utils";
import {
    API_Merchant_deleteMerchantSplitAccountInfo,
    API_Merchant_getMerchantSplitAccountInfo, API_Merchant_updateMerchantCollectionSchedule,
    API_Merchant_updateMerchantSplitAccountInfo
} from "../../../../axios/config";
import {paymentDate, totalNumberPeriods} from "../../../../axios/dictionaries";
import * as PropTypes from "prop-types";
import moment from "moment";


const Option = Select.Option;


class Page extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            merchantId:0,
            title: "创建租金汇集计划",

            data: {
                shortName:'',
                houseLayout: [],
                otherCost: [],
            },
        }
    }

    render() {
        let { visible, form: { getFieldDecorator, setFieldsValue } } = this.props;
        let {
            loading,
            title,
            data,
        } = this.state;
        return <ModalDom
            title={title}
            visible={visible}
            loading={loading}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
        >
            <div className="custom">
                <Form
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}
                >
                    <Row>
                        <Col span={24}>
                            <CustomRow>
                                <CustomCol label="商户简称">
                                    {getFieldDecorator('shortName', {
                                        rules: [{
                                             message: '商户简称',
                                        }],
                                        initialValue: data.shortName
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            disabled={true}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol label="汇集日">
                                    {getFieldDecorator('collectionDay', {
                                        rules: [{
                                            required: true, message: '请选择汇集日',
                                        }],
                                        initialValue: data.collectionDay
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择汇集日"
                                            optionFilterProp={'children'}
                                        >
                                            {paymentDate.map((item, index) => <Option value={item.value} key={index}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol  label="首次汇集月份">
                                    {getFieldDecorator("_date", {
                                        rules: [{ required: true, message: "请选择首次汇集月份" }],
                                        initialValue: data.firstCollectionMonth?moment(data.firstCollectionMonth):null
                                    })(<DatePicker.MonthPicker placeholder="首次汇集月份" month />)}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol label="总期数">
                                    {getFieldDecorator('totalNumber', {
                                        rules: [{
                                            required: true, message: '请选择总期数',
                                        }],
                                        initialValue: data.totalNumber
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择总期数"
                                            optionFilterProp={'children'}
                                        >
                                            {totalNumberPeriods.map((item, index) => <Option value={item.value} key={index}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol label="入围贷款总额" subfix={<div>万</div>} subfixRight={30}>
                                    {getFieldDecorator('totalLoan', {
                                        rules: [{
                                            required: true, message: '请输入入围贷款总额',
                                        }],
                                        initialValue: data.totalLoan
                                    })(
                                        <InputNumber>
                                            placeholder={'请输入'}
                                            min={0}
                                        </InputNumber>
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                            <CustomCol  label="是否贷款">
                                {getFieldDecorator('loan', {
                                    rules: [{required: true, message: '请选择是否贷款'}],
                                    initialValue: data.loan
                                })(
                                    <Radio.Group >
                                        <Radio value={false}>否</Radio>
                                        <Radio value>是</Radio>
                                    </Radio.Group>
                                )}
                            </CustomCol>
                            </CustomRow>
                        </Col>
                    </Row>
                </Form>
            </div>
        </ModalDom>
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    handleCancel = () => { //关闭页面
        this.props.handleCancel();
        this.setState({  loading: false, title: "创建租金汇集计划" });
    }


    loadPack = ({ id ,shortName}) => {
        this.setState({ data:{shortName:shortName},loading: false,merchantId: id, title: "创建租金汇集计划" });
    }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                let loginData = Cookies.get('loginData');
                if (loginData) {
                    loginData = JSON.parse(loginData);
                    values.merchantId = loginData.merchantId ? loginData.merchantId : 0;
                } else {
                    message.error('未登录')
                    return
                }

               // let { data: { splitAccount } } = this.state;
                this.setState({ loading: true });
                values.firstCollectionMonth = formatTime(values._date, "YYYY-MM");
                values.merchantId= this.state.merchantId;

                // if (values.id) {
                    post({ url: config.API_Merchant_updateMerchantCollectionSchedule, data: values }).then(res => {
                        message.success('操作成功');
                        this.props.handleGetList();
                        this.handleCancel();
                    }).catch(err => {
                        message.error(err.message || '操作失败');
                        this.setState({ loading: false });
                    })

            }
        })
    }
}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/Merchant/components/CollectionScheduleAdd/index.js